<template>
    <div>
        <b-navbar
            id="notification-navbar"
            v-if="variant"
            :class="{
                'alert-danger': variant == 'danger',
                'alert-warning': variant == 'warning'
            }"
        >
            <b-nav-text
                :class="{ 'text-danger': variant == 'danger' }"
                class="mr-auto ml-auto pt-0 pb-0"
            >
                <i
                    :class="{
                        'cus-exclamation': variant == 'danger',
                        'cus-error': variant == 'warning'
                    }"
                ></i>
                <span v-html="message"></span>
                <span v-if="subscription.is_patient_count">
                    <b-btn
                        v-if="_hasAccess('setting.subscription.add')"
                        @click="purchase"
                        :disabled="loading"
                        class="ml-3"
                        variant="primary"
                        >Purchase Patients</b-btn
                    >
                    <span v-else>Update subscription to add new patients.</span>
                </span>
                <span v-if="subscription.is_payment_method">
                    <b-btn
                        v-if="_hasAccess('setting.subscription.add')"
                        @click="payment"
                        :disabled="loading"
                        class="ml-3"
                        variant="primary"
                    >
                        <spinner v-if="loading" />
                        <span v-else>Add Payment</span></b-btn
                    >
                </span>
            </b-nav-text>
            <b-nav-item @click.prevent="notify" class="float-right" href
                >&times;</b-nav-item
            >
        </b-navbar>
        <editSubscription ref="editSubscriptionWindow" />
        <ModalPaymentMethodAdd
            v-if="showPaymentModal"
            ref="ModalPaymentMethodAdd"
            @close="
                () => {
                    this.showPaymentModal = false;
                }
            "
            @getPaymentMethods="update"
            @updateIsLoadingAddModal="updateIsLoadingAddModal"
        />
    </div>
</template>
<style lang="scss">
#notification-navbar {
    list-style-type: none;

    // --removed old object
    a.btn.btn-primary {
        display: none;
    }
}

@media (min-width: 992px) {
    #notification-navbar {
        position: fixed;
        width: 100%;
        z-index: 1003;
    }
}
</style>
<script>
import EditSubscription from "./edit";
import ModalPaymentMethodAdd from "@/components/setting-subscription/payment-method-add.vue";
import { isUndefined } from "lodash";
import Spinner from "@/components/elements/spinner.vue";

export default {
    components: {
        EditSubscription,
        ModalPaymentMethodAdd,
        Spinner
    },
    data() {
        return {
            subscription: {
                // // Testing purpose
                // patient_message:
                //     'Active patient count is nearing subscription limit of 1300 (1288/1300). <a href="javascript:SUBSCRIPTION.edit()" class="btn btn-primary" style="margin-left:10px;">Purchase Patients</a>',
                // patient_status: 0,
                // is_patient_count: 1,
                // patient_count: 12,
                // patient_quota: 1300,
                // notify: "0"
            },
            message: "",
            variant: false,
            loading: false,
            showPaymentModal: false
        };
    },
    watch: {
        variant() {
            this.$emit("visible");
        }
    },
    mounted() {
        this.update();
        this.$root.$on("display-subscription", () => {
            this.calcVariant();
        });

        this.$root.$on("subscription-updated", params => {
            if (params.refresh) {
                this.update();
            }
            if (!isUndefined(params.variant)) {
                this.variant = params.variant;
            }
        });

        this.$root.$on("display-subscription-limit", params => {
            this.subscription = params;
            this.calcVariant();
        });
    },
    methods: {
        notify() {
            this.loading = true;
            return $.post(
                process.env.APPS + "index.php/ajax/staff/notify",
                {},
                "json"
            )
                .then(data => {
                    if (
                        typeof data.count !== "undefined" &&
                        data.count === -1
                    ) {
                        if (data.status === 0) {
                            this.variant = "warning";
                            this.message = data.message;
                        } else {
                            this.variant = "error";
                            this.message = data.message;
                        }
                    } else {
                        this.variant = false;
                    }
                })
                .always(() => {
                    this.loading = false;
                });
        },
        update() {
            this.showPaymentModal = false;

            this._getSubscription().then(data => {
                this.subscription = data;
                if (
                    parseInt(this.subscription.notify.is_notify) === 0 ||
                    this.subscription.notify === -1
                ) {
                    this.calcVariant();
                }

                if (
                    this.subscription.account_status &&
                    this.subscription.account_status.business
                ) {
                    this.$refs["editSubscriptionWindow"].open({
                        module: "welcome"
                    });
                }
            });
        },
        calcVariant() {
            let variant = false;

            if (this.subscription.is_patient_count === 1) {
                if (this.subscription.patient_status === 0) {
                    variant = "warning";
                } else if (this.subscription.patient_status === 1) {
                    variant = "danger";
                }
                this.message = this.subscription.patient_message;
            }

            if (
                parseInt(this.subscription.notify.is_notify) === 0 &&
                this.subscription.is_payment_method === 1
            ) {
                variant = "danger";
                this.message = this.subscription.payment_message;
            }

            this.variant = variant;
            this.hasSubscriptionMessage();
        },
        purchase() {
            this.$refs["editSubscriptionWindow"].open({
                module: "edit"
            });
        },
        payment() {
            this.showPaymentModal = true;
            this.$nextTick(() => {
                this.$refs.ModalPaymentMethodAdd.open();
            });
        },
        hasSubscriptionMessage() {
            this.$emit("hasSubscriptionMessage", this.variant != false);
        },
        updateIsLoadingAddModal(isLoading) {
            this.loading = isLoading;
        }
    }
};
</script>
